import React, { SVGProps } from 'react';
type Props = {} & SVGProps<SVGSVGElement>;
export default function IconEdit(props: Props) {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            className="svg-icon-stroke"
            fill="none"
            stroke="#85858A"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9.26196 14.0977H14.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.56334 2.07402C9.12352 1.40451 10.1305 1.30634 10.8139 1.85514C10.8517 1.88491 12.0657 2.82801 12.0657 2.82801C12.8165 3.28186 13.0498 4.24669 12.5857 4.98298C12.561 5.02241 5.69752 13.6077 5.69752 13.6077C5.46917 13.8925 5.12254 14.0607 4.7521 14.0647L2.12366 14.0977L1.53144 11.5911C1.44848 11.2387 1.53144 10.8685 1.75978 10.5836L8.56334 2.07402Z"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.29285 3.66736L11.2306 6.69139" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
